import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    blocks: [
      { i: "site-network", w: 6, h: 15, x: 0, y: 0, visible: true },
      { i: "event-log", w: 2, h: 15, x: 0, y: 15, visible: true },
      { i: "alert-log", w: 4, h: 15, x: 2, y: 15, visible: true },
      { i: "event-trends", w: 2, h: 15, x: 0, y: 30, visible: true },
      { i: "system-log", w: 4, h: 15, x: 2, y: 30, visible: true },
      { i: "people-flow", w: 6, h: 15, x: 0, y: 45, visible: true },
      { i: "traffic-stats", w: 6, h: 15, x: 0, y: 60, visible: true },
      { i: "nvr-info", w: 6, h: 15, x: 0, y: 75, visible: true },
    ]
  },
  resource: "/users/dashboard",
  total: 8
};

export const surveillanceDashboardSlice = createSlice({
  name: "surveillanceDashboard",
  initialState,
  reducers: {
    setSurveillanceBlocks: (state, action) => {
      state.data.blocks = action.payload;
    },
  },
});

export const { setSurveillanceBlocks } = surveillanceDashboardSlice.actions;

export default surveillanceDashboardSlice.reducer;